import { FC, useState } from 'react';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { media } from '@/shared/components';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { VideoRerecordConfirmModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const VideoRerecordConfirmModal: FC<VideoRerecordConfirmModalProps> = ({ onSubmit }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'videoRerecordConfirm' });
  const [loading, setLoading] = useState(false);

  const modals = useModalsStore();

  const handleClick = () => {
    setLoading(true);
    onSubmit();
  };

  return (
    <ModalContainerV2 pinBottom title={t('title')}>
      <Content>
        <span>{t('text')}</span>
        <Buttons>
          <ButtonIw type="default" onClick={() => modals.closeModal()}>
            {t('cancel')}
          </ButtonIw>
          <ButtonIw disabled={loading} loading={loading} onClick={handleClick}>
            {t('submit')}
          </ButtonIw>
        </Buttons>
      </Content>
    </ModalContainerV2>
  );
};

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 32px;
  gap: 16px;

  ${media.iwMobile} {
    flex-direction: column-reverse;
  }
`;

const Content = styled.div`
  padding: 24px 0 0;
  font-size: 14px;
`;
